import { setFileList } from '../State/fileList';

export default (file) => (dispatch, getState) => {
  
  const { fileList } = getState().modals.EmailValuation;

  const newFileList = [ ...fileList, file ];

  dispatch(setFileList(newFileList));

  return false;

}